// extracted by mini-css-extract-plugin
export default {"main":"drawer_main__C0tfp","logo_container":"drawer_logo_container__87BEC","MuiDrawer-paper":"drawer_MuiDrawer-paper__Eigx0"};